<template>
  <div>
    <div v-if="schedule" class="p-grid">
      <div class="p-col-2" :class="{ 'p-col-4': isMobile }">
        <a href="https://cactusware.com" target="_blank"
          ><img
            @click="printing = false"
            style="width: 100%; margin: 0 auto; max-width: 200px"
            src="https://diamond-public.s3.us-west-2.amazonaws.com/assets/diamond-logo-white.png"
        /></a>
        <br />
        <div style="font-size: 10px">{{ $t('lastUpdated') }}: {{ schedule.updated_at | moment("LLLL") }}</div>
      </div>
      <div v-show="!isMobile" class="p-col-6">
        <h1 class="title is-4">{{ $t("schedule-schedule-name", [schedule.name]) }}</h1>
        <!-- <small> Last Updated: {{ schedule.updated_at | moment("LLLL") }} </small> -->
      </div>
      <div class="p-col-2" :class="{ 'p-col-4': isMobile }">
        <b-field :label="$t('Team.teams')">
          <b-select :placeholder="$t('Calendar.all_teams')" expanded v-model="filterTeam">
            <option v-for="(option, i) in filters.teams" :value="option.value" :key="option.value + '-' + (i || 't1')">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="p-col-2" :class="{ 'p-col-4': isMobile }">
             <b-field :label="$t('AppMenu.venues')">
          <b-select :placeholder="$t('Calendar.all_venues')" expanded v-model="filterVenue">
            <option v-for="(option, i) in filters.venues" :value="option.value" :key="option + ' ' + (i || 'v1')">
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div v-if="busy">
      <ProgressSpinner />
    </div>
    <div v-else>
      <b-table
        :data="filteredData"
        :columns="columns"
        :mobile-cards="false"
        :striped="true"
        :narrowed="(this.data && this.data.length > 50) || this.isMobile"
        :style="tableStyle"
      ></b-table>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      isMobile: false,
      data: [],
      schedule: {},
      busy: true,
      filterTeam: "All Teams",
      filterVenue: "All Venues",
      columns: [
        {
          field: "Date",
          label: this.$t("GameTable.column.date"),
          centered: true,
        },
        {
          field: "Time",
          label: this.$t("GameTable.column.time"),
          centered: true,
        },
        {
          field: "Visitor",
          label: this.$t("GameTable.column.visitor"),
          centered: true,
        },
        {
          field: "Home",
          label: this.$t("GameTable.column.home"),
          centered: true,
        },
        {
          field: "Venue",
          label: this.$t("GameTable.column.venue"),
          centered: true,
        },
        {
          field: "Surface",
          label: this.$t("GameTable.column.surface"),
          centered: true,
        },
        {
          field: "Game Score",
          label: this.$t("GameTable.column.game-score"),
          centered: true,
        },
      ],
    };
  },
  computed: {
    filteredData() {
      console.log("🌨 ", this.filterTeam, this.filterVenue);
      var x = this.data;
      var y = x;
      if (this.filterTeam != "All Teams") {
        var y = [];
        this.data.forEach(item => {
          if (this.filterTeam == item.Home || this.filterTeam == item.Visitor) {
            y.push(item);
          }
        });
      }
      var z = y;
      if (this.filterVenue != "All Venues") {
        var z = [];
        this.data.forEach(item => {
          if (this.filterVenue == item.Venue) {
            z.push(item);
          }
        });
      }

      return z;
    },
    tableStyle() {
      var fontSize = "14px";
      if (window.innerWidth < 500) {
        fontSize = "10px";
      } else if (window.innerWidth < 700) {
        fontSize = "11px";
      } else if (window.innerWidth < 900) {
        fontSize = "12px";
      } else if (window.innerWidth < 1100) {
        fontSize = "13px";
      }
      return { fontSize: fontSize };
    },
    filters() {
      if (this.data) {
        var teams = [{ name: this.$t("Calendar.all_teams"), value: "All Teams" }];
        var venues = [{ name: this.$t("Calendar.all_venues"), value: "All Venues" }];
        var usedTeams = [];
        var usedVenues = [];
        var surfaces = [];
        this.data.forEach(item => {
          if (!usedTeams.includes(item.Home)) {
            teams.push({ name: item.Home, value: item.Home });
            usedTeams.push(item.Home);
          }
          if (!usedVenues.includes(item.Venue)) {
            venues.push({ name: item.Venue, value: item.Venue });
            usedVenues.push(item.Venue);
          }
        });
      }
      return {
        teams: teams,
        venues: venues,
        surfaces: surfaces,
      };
    },
  },
  created() {},
  mounted() {
    this.isMobile = window.innerWidth < 800;
    api
      .getEmbed(this.$route.params.id)
      .then(response => {
        console.log("Embed response: ", response);
        this.data = response.data.results;
        this.schedule = response.data.schedule;
        this.busy = false;
      })
      .catch(e => {});
  },
};
</script>

<style scoped lang="scss"></style>